document.documentElement.classList.remove('no-js');

const qs=(selector,context=document)=>context.querySelector(selector);
const qsa=(selector,context=document)=>[...context.querySelectorAll(selector)];
const shopRoot=window.Shopify?.routes?.root||'/';
const formatMoney=(cents,currency='EUR')=>{
  const amount=Number(cents||0)/100;
  if(currency==='EUR')return `€${new Intl.NumberFormat('el-GR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(amount)}`;
  return new Intl.NumberFormat(document.documentElement.lang||'el-GR',{style:'currency',currency}).format(amount);
};
const checkoutPermalink=(domain,items)=>`https://${domain}/cart/${items.map(item=>`${item.variant_id}:${item.quantity}`).join(',')}`;

const menuButton=qs('[data-menu-toggle]');
const nav=qs('[data-nav]');
if(menuButton&&nav){
  menuButton.addEventListener('click',()=>{
    const open=nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded',String(open));
    document.body.classList.toggle('menu-open',open);
  });
  qsa('a',nav).forEach(link=>link.addEventListener('click',()=>{
    nav.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    menuButton.setAttribute('aria-expanded','false');
  }));
}

const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.isIntersecting){
    entry.target.classList.add('is-visible');
    observer.unobserve(entry.target);
  }
}),{threshold:.12});
qsa('.reveal').forEach(element=>observer.observe(element));

const setGalleryImage=(root,src,alt='',mediaId='')=>{
  if(!src)return;
  const gallery=qs('[data-gallery]',root);
  const main=gallery&&qs('[data-gallery-main]',gallery);
  if(!main)return;
  main.src=src;
  main.alt=alt||main.alt;
  qsa('[data-gallery-thumb]',gallery).forEach(button=>button.classList.toggle('is-active',String(button.dataset.mediaId||'')===String(mediaId||'')||(mediaId===''&&button.dataset.src===src)));
};
qsa('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>setGalleryImage(button.closest('[data-product-root]'),button.dataset.src,button.dataset.alt,button.dataset.mediaId)));

qsa('[data-product-root]').forEach(root=>{
  const form=qs('[data-product-form]',root);
  if(!form)return;
  const qty=qs('input[name="quantity"]',form);
  const variantSelect=qs('[data-variant-select]',form);
  const addButton=qs('button[type="submit"]',form);
  const addLabel=addButton&&qs('span',addButton);
  const buyNow=qs('[data-buy-now]',form);
  const optionGroups=qsa('[data-option-group]',form);
  const variantOptions=variantSelect?[...variantSelect.options]:[];
  const currency=root.dataset.currency||'EUR';

  const updateProductTotal=()=>{
    const price=qs('[data-product-price]',root);
    if(!price||!qty)return;
    const unitPrice=Number(price.dataset.unitPrice||0);
    const quantity=Math.max(1,Number(qty.value)||1);
    const total=formatMoney(unitPrice*quantity,currency);
    price.textContent=total;
    const stickyPrice=qs('[data-sticky-buy] strong',root);
    if(stickyPrice)stickyPrice.textContent=total;
  };

  qs('[data-qty-minus]',form)?.addEventListener('click',()=>{
    qty.value=Math.max(1,Number(qty.value)-1);
    updateProductTotal();
  });
  qs('[data-qty-plus]',form)?.addEventListener('click',()=>{
    qty.value=Number(qty.value)+1;
    updateProductTotal();
  });
  qty?.addEventListener('input',()=>{
    if(Number(qty.value)<1)qty.value=1;
    updateProductTotal();
  });
  qs('[data-scroll-size]',root)?.addEventListener('click',()=>document.querySelector('#size-guide')?.scrollIntoView({behavior:'smooth'}));
  qs('[data-sticky-submit]',root)?.addEventListener('click',()=>addButton?.click());

  const optionValue=(option,position)=>option?.dataset[`option${position}`]||'';
  const selectedValues=()=>optionGroups.map(group=>qs('[data-option-choice].is-selected',group)?.dataset.optionValue||'');
  const matchingVariant=values=>variantOptions.find(option=>values.every((value,index)=>optionValue(option,index+1)===value));
  const syncPicker=()=>{
    if(!variantSelect)return;
    const selected=variantSelect.selectedOptions[0];
    if(!selected)return;
    optionGroups.forEach(group=>{
      const position=Number(group.dataset.optionPosition);
      const value=optionValue(selected,position);
      qsa('[data-option-choice]',group).forEach(button=>{
        const active=button.dataset.optionValue===value;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',String(active));
      });
      const label=qs('[data-selected-option-label]',group);
      if(label)label.textContent=value;
    });
    const values=selectedValues();
    qsa('[data-option-choice]',form).forEach(button=>{
      const testValues=[...values];
      testValues[Number(button.dataset.optionPosition)-1]=button.dataset.optionValue;
      const candidate=matchingVariant(testValues);
      button.classList.toggle('is-unavailable',!candidate||candidate.dataset.available==='false');
      button.setAttribute('aria-disabled',String(!candidate));
    });
  };

  qsa('[data-option-choice]',form).forEach(button=>button.addEventListener('click',()=>{
    const values=selectedValues();
    values[Number(button.dataset.optionPosition)-1]=button.dataset.optionValue;
    const match=matchingVariant(values);
    if(!match)return;
    variantSelect.value=match.value;
    variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
    if(button.dataset.previewSrc)setGalleryImage(root,button.dataset.previewSrc,button.dataset.previewAlt,button.dataset.previewMediaId);
  }));

  variantSelect?.addEventListener('change',()=>{
    const option=variantSelect.selectedOptions[0];
    if(!option)return;
    setGalleryImage(root,option.dataset.imageSrc,option.dataset.imageAlt,option.dataset.mediaId);
    const price=qs('[data-product-price]',root);
    if(price)price.dataset.unitPrice=option.dataset.priceCents||0;
    const available=option.dataset.available!=='false';
    if(addButton){
      addButton.disabled=!available;
      if(addLabel)addLabel.textContent=available?"ΒΑΛ' ΤΟ ΣΤΟ ΚΑΛΑΘΙ":'ΕΞΑΝΤΛΗΘΗΚΕ';
    }
    if(buyNow)buyNow.disabled=!available;
    syncPicker();
    updateProductTotal();
    const url=new URL(window.location.href);
    url.searchParams.set('variant',option.value);
    window.history.replaceState({},'',url);
  });

  syncPicker();
  updateProductTotal();

  buyNow?.addEventListener('click',()=>{
    const variantId=variantSelect?.value||qs('input[name="id"]',form)?.value;
    const quantity=Math.max(1,Number(qty?.value)||1);
    const domain=root.dataset.shopDomain;
    if(variantId&&domain)window.location.assign(`https://${domain}/cart/${variantId}:${quantity}`);
  });

  form.addEventListener('submit',async event=>{
    event.preventDefault();
    addButton?.setAttribute('disabled','disabled');
    try{
      const response=await fetch(`${shopRoot}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok)throw new Error('cart');
      const cart=await fetch(`${shopRoot}cart.js`).then(result=>result.json());
      qsa('[data-cart-count]').forEach(element=>element.textContent=cart.item_count);
      const toast=qs('[data-cart-toast]');
      toast?.classList.add('is-visible');
      setTimeout(()=>toast?.classList.remove('is-visible'),2600);
    }catch(error){
      window.location.href=`${shopRoot}cart`;
    }finally{
      addButton?.removeAttribute('disabled');
    }
  });

  const sticky=qs('[data-sticky-buy]',root);
  if(sticky){
    const stickyObserver=new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:0});
    stickyObserver.observe(form);
  }
});

const cartRoot=qs('[data-cart-root]');
if(cartRoot){
  const currency=cartRoot.dataset.currency||'EUR';
  const domain=cartRoot.dataset.shopDomain;
  const setCartLoading=(card,loading)=>{
    card.classList.toggle('is-updating',loading);
    qsa('button,input',card).forEach(control=>control.disabled=loading);
  };
  const refreshCartUI=cart=>{
    qsa('[data-cart-count]').forEach(element=>element.textContent=cart.item_count);
    const pageCount=qs('[data-cart-page-count]',cartRoot);
    const summaryCount=qs('[data-cart-summary-count]',cartRoot);
    const subtotal=qs('[data-cart-subtotal]',cartRoot);
    const total=qs('[data-cart-total]',cartRoot);
    const checkout=qs('[data-cart-checkout]',cartRoot);
    if(pageCount)pageCount.textContent=cart.item_count;
    if(summaryCount)summaryCount.textContent=cart.item_count;
    if(subtotal)subtotal.textContent=formatMoney(cart.items_subtotal_price,currency);
    if(total)total.textContent=formatMoney(cart.total_price,currency);
    if(checkout&&domain)checkout.href=checkoutPermalink(domain,cart.items);
  };
  const changeLine=async(card,quantity)=>{
    if(card.classList.contains('is-updating'))return;
    const key=card.dataset.lineKey;
    setCartLoading(card,true);
    try{
      const response=await fetch(`${shopRoot}cart/change.js`,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity})
      });
      if(!response.ok)throw new Error('cart-update');
      const cart=await response.json();
      if(cart.item_count===0){window.location.reload();return;}
      const item=cart.items.find(cartItem=>cartItem.key===key);
      if(!item){
        card.remove();
      }else{
        const input=qs('[data-cart-quantity]',card);
        const linePrice=qs('[data-cart-line-price]',card);
        if(input)input.value=item.quantity;
        if(linePrice)linePrice.textContent=formatMoney(item.final_line_price,currency);
      }
      refreshCartUI(cart);
    }catch(error){
      window.location.reload();
    }finally{
      if(document.body.contains(card))setCartLoading(card,false);
    }
  };

  qsa('[data-cart-line]',cartRoot).forEach(card=>{
    const input=qs('[data-cart-quantity]',card);
    qs('[data-cart-minus]',card)?.addEventListener('click',()=>changeLine(card,Math.max(0,Number(input.value)-1)));
    qs('[data-cart-plus]',card)?.addEventListener('click',()=>changeLine(card,Number(input.value)+1));
    qs('[data-cart-remove]',card)?.addEventListener('click',()=>changeLine(card,0));
    input?.addEventListener('change',()=>changeLine(card,Math.max(0,Number(input.value)||0)));
  });
}